export const calculateLoanAmount = (
  totalCost: number,
  investment: number,
  hasWarranty: boolean,
  warrantyCost: number
): number => {
  const total = hasWarranty ? totalCost + warrantyCost : totalCost;
  return total - investment;
};
